module.exports = __webpack_public_path__ + "img/Plastic-Whore-no-logo.f73fb423.jpg";